import Glide from '@glidejs/glide'

export default () => ({
        carousel: null,
        get activeSlide() {
            return this.carousel.index;
        },
        prev() {
            this.carousel.go('<');
        },
        next() {
            this.carousel.go('>');
        },

        setPadding() {
        },

        init() {
            this.setPadding()
            this.carousel = new Glide(this.$refs.carousel, {
                type: 'slideshow',
                perView: 1,
                autoplay: false,
                focusAt: 0,
            })
            this.carousel.mount()
        },
})
